module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_5010.0b5a0612.png";